<template>
  <TopNav></TopNav>
  <h1>Fuel Cost Calculator</h1>
  <fieldset>
    <legend>Fuel Cost Calculator</legend>
    <label for="a">Trip Distance: </label> <input type="number" v-model.number="distance" id="a" step="any"> ㎞
    <br>
    <label for="b">Fuel Efficiency: </label> <input type="number" v-model.number="efficiency" id="b" step="any"> L/100㎞
    <br>
    <label for="b">Fuel Price: </label> <input type="number" v-model.number="fuelPrice" id="b" step="any"> $ per <span title="liter">L</span>
    <br><br>
    This trip will cost you <span class="blue">${{ cost() }}</span>. This calculation doesn't include return trip.
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "FuelCost",
  data() {
    return {
      formatter: new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2
      }),
      distance: 100,
      efficiency: 10,
      fuelPrice: 3,
    }
  },
  components: {
    TopNav
  },
  methods: {
    cost: function () {
      let cost = (this.distance * this.efficiency * this.fuelPrice) / 100;
      return this.formatter.format(cost);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  min-width: 135px;
}

input[type=number] {
    width: 100px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
